import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import StatusDot from 'components/Relatorios/shared/Aprovacao/StatusDot';
import { DESSEM_APROVACAO_VERDE_ESCURO } from 'constants/colors';

import { SecaoAprovacaoStatus } from 'types/Relatorios/Aprovacao';

import './index.scss';

export interface SecaoStatusPillProps {
  status: SecaoAprovacaoStatus;
}

/** Pill "✓ Aprovada" (verde) ou "● Pendente de aprovação" (âmbar). */
export default function SecaoStatusPill({ status }: SecaoStatusPillProps) {
  const aprovada = status === 'aprovada';

  return (
    <span className={`relatorio-aprovacao-secao-status-pill ${aprovada ? 'relatorio-aprovacao-secao-status-pill--aprovada' : 'relatorio-aprovacao-secao-status-pill--pendente'}`}>
      {aprovada ? <Icon iconType="checkmark" size="small" color={DESSEM_APROVACAO_VERDE_ESCURO} /> : <StatusDot status="pendente" />}
      <SubtitleRegular>{aprovada ? 'Aprovada' : 'Pendente de aprovação'}</SubtitleRegular>
    </span>
  );
}
